(() => {
  function init() {
    document.querySelectorAll('[data-am-guide-open]').forEach(button => {
      if (button.dataset.amBound) return;
      button.dataset.amBound = 'true';
      const dialog = document.getElementById(button.dataset.amGuideOpen);
      if (!dialog) return;
      button.addEventListener('click', () => dialog.showModal());
      dialog.querySelector('[data-am-guide-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
    });
    document.querySelectorAll('[data-product-root]').forEach(root => {
      const group = root.querySelector('[data-am-size-group]');
      if (!group || group.dataset.amBound) return;
      group.dataset.amBound = 'true';
      const error = root.querySelector('[data-am-size-error]');
      let chosen = new URLSearchParams(location.search).has('variant');
      const price = root.querySelector('[data-am-start-price]');
      function showStartingPrice() {
        if (!chosen && price) {
          price.textContent = price.dataset.amStartPrice;
          const stickyPrice = root.querySelector('[data-sticky-price]');
          if (stickyPrice) stickyPrice.textContent = price.dataset.amStartPrice;
        }
      }
      function clearImplicitSelection() {
        if (chosen) return;
        group.querySelectorAll('[data-option-value]').forEach(button => {
          button.classList.remove('is-active');
          button.setAttribute('aria-pressed', 'false');
        });
        const label = group.querySelector('[data-option-value-current]');
        if (label) label.textContent = group.dataset.amSizePlaceholder;
      }
      clearImplicitSelection();
      document.addEventListener('am:variant-change', () => {
        clearImplicitSelection();
        showStartingPrice();
      });
      window.addEventListener('load', showStartingPrice, { once: true });
      group.addEventListener('click', event => {
        const button = event.target.closest('[data-option-value]');
        if (!button || button.disabled) return;
        chosen = true;
        if (error) error.hidden = true;
      }, true);
      document.addEventListener('submit', event => {
        if (chosen || !event.target.matches('.pdp__form, .stickybar__form')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (error) error.hidden = false;
        group.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        group.querySelector('[data-option-value]:not([disabled])')?.focus({ preventScroll: true });
      }, true);
    });
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

/* Motion enhances off-screen content; visible products and buying controls never hide. */
(() => {
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '.am-lane, .am-edit__head, .am-edit .am-card, .am-story__body, .am-related__head, .am-related .card, .am-newsletter';
  let observer;
  function reveal() {
    document.querySelectorAll('.am-reveal-pending').forEach(el => {
      el.classList.remove('am-reveal-pending'); el.classList.add('am-reveal-visible');
    });
    observer?.disconnect();
  }
  function initMotion(scope = document) {
    if (preference.matches || !('IntersectionObserver' in window)) return;
    observer ||= new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        el.classList.replace('am-reveal-pending', 'am-reveal-visible');
        observer.unobserve(el);
      });
    }, {rootMargin: '0px 0px 30px 0px', threshold: .04});
    scope.querySelectorAll(selector).forEach((el, index) => {
      if (el.dataset.amMotion || el.getBoundingClientRect().top < innerHeight) return;
      el.dataset.amMotion = 'true';
      el.style.setProperty('--am-reveal-delay', `${(index % 4) * 45}ms`);
      el.classList.add('am-reveal-pending'); observer.observe(el);
    });
  }
  document.addEventListener('DOMContentLoaded', () => initMotion());
  document.addEventListener('shopify:section:load', event => initMotion(event.target));
  preference.addEventListener('change', event => { if (event.matches) reveal(); else initMotion(); });
  // Jump links and page search must reveal their destination immediately.
  document.addEventListener('beforematch', reveal);
})();

(() => {
  function initGallery(scope = document) {
    scope.querySelectorAll('[data-product-root]').forEach(root => {
      const gallery = root.querySelector('[data-am-gallery]');
      if (!gallery || gallery.dataset.amGalleryBound) return;
      gallery.dataset.amGalleryBound = 'true';
      const thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
      const media = Array.from(gallery.querySelectorAll('[data-product-media]'));
      const controls = gallery.querySelector('[data-am-gallery-controls]');
      const count = gallery.querySelector('[data-am-photo-count]');
      const zoomAction = gallery.querySelector('[data-am-zoom-action]');
      const dialog = root.parentElement.querySelector('[data-am-photo-dialog]');
      const header = document.querySelector('.section-header');
      const updateTop = () => gallery.style.setProperty('--am-gallery-top', `${(header?.getBoundingClientRect().height || 106) + 16}px`);
      updateTop();
      if (header && 'ResizeObserver' in window) new ResizeObserver(updateTop).observe(header);
      const large = dialog?.querySelector('[data-am-photo-large]');
      function index() { return Math.max(0, media.findIndex(el => !el.hidden)); }
      function sync() {
        if (count) count.textContent = `${index() + 1} / ${media.length}`;
        if (zoomAction) zoomAction.hidden = !media[index()]?.querySelector('[data-am-zoom-open]') || !dialog;
        const active = thumbs[index()];
        if (!active) return;
        const rail = active.parentElement;
        const r = rail.getBoundingClientRect(), a = active.getBoundingClientRect();
        if (getComputedStyle(rail).flexDirection === 'column') {
          if (a.bottom > r.bottom) rail.scrollTop += a.bottom - r.bottom;
          else if (a.top < r.top) rail.scrollTop -= r.top - a.top;
        } else {
          if (a.right > r.right) rail.scrollLeft += a.right - r.right;
          else if (a.left < r.left) rail.scrollLeft -= r.left - a.left;
        }
      }
      controls.hidden = false;
      gallery.querySelectorAll('[data-am-photo-step]').forEach(button => button.addEventListener('click', () => {
        const next = (index() + Number(button.dataset.amPhotoStep) + media.length) % media.length;
        thumbs[next]?.click();
      }));
      new MutationObserver(records => {if (records.some(record => record.target.matches('[data-product-media]'))) sync();}).observe(gallery.querySelector('[data-stage]'), {subtree:true,attributes:true,attributeFilter:['hidden']});
      let previousOverflow = '';
      function openZoom() {
        const imageButton = media[index()]?.querySelector('[data-am-zoom-open]');
        if (!imageButton || !dialog || dialog.open || typeof dialog.showModal !== 'function') return;
        large.src = imageButton.dataset.amFullSrc;
        large.alt = imageButton.querySelector('img').alt;
        previousOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      }
      gallery.querySelectorAll('[data-am-zoom-open]').forEach(button => button.addEventListener('click',openZoom));
      zoomAction?.addEventListener('click',openZoom);
      dialog?.querySelector('[data-am-photo-close]')?.addEventListener('click',() => dialog.close());
      dialog?.addEventListener('close',() => {document.documentElement.style.overflow = previousOverflow;});
      dialog?.addEventListener('click',event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
      sync();
    });
  }
  document.addEventListener('DOMContentLoaded',() => initGallery());
  document.addEventListener('shopify:section:load',event => initGallery(event.target));
})();
